import React from "react";
import { IoIosAlarm } from "react-icons/io";
import { FaMobileAlt } from "react-icons/fa";
import { MdOutlineSettingsSuggest } from "react-icons/md";
import { NavLink } from "react-router-dom";

const AboutSection = () => {
  const aboutList = [
    {
      icon: <FaMobileAlt />,
      tite: "Powerful Mobile & Online App",
      content:
        "Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque .",
    },
    {
      icon: <IoIosAlarm />,
      tite: "Brings More Transperency & Speed",
      content:
        "Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque .",
    },
    {
      icon: <MdOutlineSettingsSuggest />,
      tite: "Special For Multiple User Capabilities",
      content:
        "Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque .",
    },
  ];

  return (
    <div className="about_section  section-padding">
      <div className="container px-sm-1 px-4">
        <div className="row position-relative">
            <div className="about_shape" data-aos='zoom-in' >
                <img src="/image/about-section/about-shape.png" className="img-fluid" alt="" />
            </div>
          {/* IMAGE SECTION */}
          <div className="col-lg-6 pe-lg-5">
            <div className="row index-1">
              <div className="col-6">
                <div className="about_img" data-aos='zoom-in' >
                <img
                    src="/image/about-section/img-1.jpg"
                    className="img-fluid rounded-4 mb-4"
                    alt=""
                  />
                  <img
                    src="/image/about-section/img-2.jpg"
                    className="img-fluid rounded-4 mb-4"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-6 padding-top">
                <div className="about_img" data-aos='zoom-in' >
                <img
                    src="/image/about-section/img-3.jpg"
                    className="img-fluid rounded-4 mb-4"
                    alt=""
                  /> <img
                  src="/image/about-section/img-4.jpg"
                  className="img-fluid rounded-4 mb-4"
                  alt=""
                />
                </div>
              </div>
            </div>
          </div>
          {/* CONTENT SECTION */}
          <div className="col-lg-6 ps-lg-5">
            <div className="about_content">
              <p  data-aos='fade-up'  className="mb-4 text-style text-green text-uppercase" >about us</p>
              <h2 data-aos='fade-up'  className="text-black fw-700">Transfer & Exchange Your Money Anytime Inthis World</h2>
              <p  data-aos='fade-up'  className="my-md-5 my-4 text-justiy-left text-color">
                Best Strategic planning dolor sit amet consectetur adipiscing
                elit. Scel erus isque ametus odio velit auctor nam elit nulla
                eget sodales dui pulvinar dolor strategic planning dolor sit
                sectetur morethe.
              </p>
              {aboutList.map((element, index) => {
                return (
                  <div key={index} className="about_list  mt-4 d-flex   align-items-start" data-aos='fade-up' >
                    <div className="list_img me-4">{element.icon}</div>
                    <div className="list_content">
                      <h5 className="fw-700 text-black">{element.tite}</h5>
                      <p className="mt-4 mb-0 text-justify-left">
                        {element.content}
                      </p>
                    </div>
                  </div>
                );
              })}

                <NavLink to='/converter' className='btn btn-primary mt-md-5 mt-4' data-aos='zoom-in' >read more</NavLink>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
